import { Component, ElementRef, Input, OnInit, ViewChild } from "@angular/core";
import { BehaviorSubject, Subject } from "rxjs";
import { FlowNode } from "../../flow-node.controller";
import ResizeObserver from "resize-observer-polyfill";

@Component({
  selector: "app-flow-menu",
  templateUrl: "./flow-menu.component.html",
  styleUrls: ["./flow-menu.component.scss"],
  host: { class: "flow-menu-component" },
})
export abstract class FlowMenuComponent implements OnInit {
  mutationObserver!: MutationObserver;
  resizeObserver!: ResizeObserver;
  constructor() {}
  @Input() node!: FlowNode;
  @Input() selected!: boolean;
  @Input() onMenuSizeChange!: Subject<any>;
  @ViewChild("nodeMenuElement") nodeMenuElement!: ElementRef;
  onMenuOpenChange = new BehaviorSubject<boolean>(!!this.selected);
  onNodeMenuInstantiated = new Subject<void>();
  onComponentDestroy = new Subject();
  @Input() internal: boolean = false;

  ngOnInit(): void {
  }

  ngAfterViewInit() {
    this.mutationObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        //If hidden changes, emit value to subject
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "hidden"
        ) {
          this.onMenuOpenChange.next(
            !this.nodeMenuElement.nativeElement.hidden,
          );
        }
      });
    });

    this.mutationObserver.observe(this.nodeMenuElement.nativeElement, {
      attributes: true,
      childList: true,
      characterData: true,
    });

    this.resizeObserver = new ResizeObserver((entries) => {
      if (this.isOpen) {
        this.onMenuSizeChange.next();
      }
    });

    this.resizeObserver.observe(this.nodeMenuElement.nativeElement);

    this.onNodeMenuInstantiated.next();
    this.onNodeMenuInstantiated.complete();
  }

  ngOnDestroy() {
    this.mutationObserver.disconnect();
    this.resizeObserver.disconnect();
    if (this.isOpen) {
      this.onMenuOpenChange.next(false);
    }
    this.onMenuOpenChange.complete();

    this.onComponentDestroy.next();
    this.onComponentDestroy.complete();
  }

  get isOpen() {
    return this.selected;
  }

  get invalid() {
    return false;
  }

  get nodeDTO() {
    return {};
  }
}
